<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Paparan Embrio" >
      <w-card bg-color="" class="">
          
            <div class="w-flex wrap smd-column" >
              <div class="grow ">
                   <div class="fw-normal my1 fs-1"><b>Kod :</b><br>{{data.kode}}&nbsp;</div>
                   <div class="fw-normal my1 fs-1"><b>Ternakan :</b><br>{{data.ternakan}}&nbsp;</div>
                   <div class="fw-normal my1 fs-1"><b>Jantina :</b><br>{{data.jantina_lebel}}&nbsp;</div>
                   <div class="fw-normal my1 fs-1"><b>AI MAN :</b><br>{{data.alman}}&nbsp;</div>
                   <div class="fw-normal my1 fs-1"><b>Status :</b><br>{{data.status}}&nbsp;</div>
                   <div class="fw-normal my1 fs-1"><b>Amaun :</b><br>{{data.amaun}}&nbsp;</div>
                   <div class="fw-normal my1 fs-1"><b>Tarikh :</b><br>{{data.tarikh}}&nbsp;</div>
                   <div class="fw-normal my1 fs-1"><b>Tangki :</b><br>{{data.tangki}}&nbsp;</div>

              </div>
              <div class="mx2"></div>
              <div class="grow ">
                   <div class="fw-normal my1 fs-1"><b>Baka Jantan :</b><br>{{data.baka}}&nbsp;</div>
                   <div class="fw-normal my1 fs-1"><b>Jantan :</b><br><inertia-link :href="$route('baka.show', data.baka_id)" >{{data.baka_jantan}}</inertia-link>&nbsp;</div>
                   <div class="fw-normal my1 fs-1"><b>Semen :</b><br>{{data.semen}}&nbsp;</div>
                   <div class="fw-normal my1 fs-1"><b>Baka Betina :</b><br>{{data.bakaInduk}}&nbsp;</div>
                   <div class="fw-normal my1 fs-1"><b>Betina :</b><br><inertia-link :href="$route('baka.show',data.baka_induk_id)" >{{data.baka_betina}}</inertia-link>&nbsp;</div>
                   <div class="fw-normal my1 fs-1"><b>Sel telur :</b><br>{{data.sel_telur}}&nbsp;</div>

                <br>
                <!-- <w-flex class="flex justify-left">
                 <w-button  bg-color="warning"  :route="$route('premis.form',data.id)" class="be fs-2">
                    <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini 
                  </w-button>
                </w-flex> -->
                <br>
                
              </div>
            </div>
      </w-card>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: this.api_service + "embrio",
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Embrio', route: '/embrio' },
        { label: 'Papar', route: '/embrio/'+this.id },
      ],
      data : {id : 0, baka_induk_id : 0, baka_id : 0},
      attahecment : [],
      slides : [],
      activeTab : 0,
      tabs: [
      		  
          ]
    }
  },
  methods: {
    getData()
    {
      this.$zcomm.get(this.api_service + 'embrio/show/'+this.id, {}).then(res => {
        this.data = res
      })
    },

    
   

  },
  watch: {

  },
  mounted() {
    this.getData();
    
  },
}
</script>
